import { Spinner } from 'construct-ui';
import SingleSelectComponent from '../../components/single-select/single-select.component';
import goodMovementModel from '../../models/posm/goods-movement.model';
import POSMAuthorizationModel, { POSM_PERMISSION_KEY } from '../../models/posm/posm-authority.model';
import ViewBase from '../view-base.view';
import CreatePOSMGoodsMovementDialog from './create-goods-movement.dialog';
import DisplayAllGoodmovement from './display-all-goodmovement.view';
import { POSMGoodsMovementFooter } from './posm-goods-movement-footer';
import POSMmovementTypeView from './posm-movement-type.view';
import moment from 'moment';
import { formats } from '../../config/constants';
import { ASCENDING_TEXT, DESCENDING_TEXT } from '../../models/posm/posm.constant';
/**
 *
 *
 * @author
 */


export default function POSMGoodsMovement() {
  ViewBase.call(this);
  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1
  }
  const DEFAULT_FILTERS = {
    DateFrom: moment().subtract(1, 'M').startOf('M').format(formats.apiDateFormat),
    DateTo: moment().format(formats.apiDateFormat),
    MovementBy: "",
    ChannelCd: "",
    VendorID: "",
  };

  const CATEGORY_ORDER = {
    MAIN: 0,
    GOODS_TYPE: 1,
    DIVISION: 2,
    MODEL: 3,
    BASIC_MODEL: 4,
    MOVEMENT_TYPES: 5,
    WAREHOUSE: 6,
    STORARE_LOCATION: 7,
  };
  const CREATE_GOODS_MOVEMENT_AUTHORITY_MAP = {
    'GR': POSM_PERMISSION_KEY.GOODS_RECEIVE,
    'WM': POSM_PERMISSION_KEY.GOODS_MOVEMENT,
    'GI': POSM_PERMISSION_KEY.GOODS_ISSUE,
    'RE': POSM_PERMISSION_KEY.GOODS_RETURN,
    'SC': POSM_PERMISSION_KEY.SCRAP_GOODS,
  };

  let listGoodMovement = [];
  let totalListGoodMovement = 0;
  let movementDetail = structuredClone({
    main: goodMovementModel?.movementDetail?.main,
    goodsType: goodMovementModel?.movementDetail?.goodsType,
    division: goodMovementModel?.movementDetail?.division,
    model: goodMovementModel?.movementDetail?.model,
    basicModel: goodMovementModel?.movementDetail?.basicModel,
  });
  let filterObj = structuredClone(DEFAULT_FILTERS);
  let paginationObj = structuredClone(DEFAULT_PAGINATION);
  let currentFilter = {};
  let MOVEMENT_OPTIONS = {
    main: goodMovementModel.main,
    goodsType: goodMovementModel.goodsType,
    division: goodMovementModel.division,
    model: goodMovementModel.model,
    basicModel: goodMovementModel.basicModel,
  };

  let isHierachyLoading = false;
  let isCreateMovementDialogOpen = false;
  let currentInputGoodTypeOrder = 0;
  const setPaginationObj = (paginationObjPatch) => {
    paginationObj = { ...paginationObj, ...paginationObjPatch };
    currentFilter = { ...currentFilter, ...paginationObj };
  }

  let movementControlCode = ''

  const setFilterObj = (filterObjPatch) => {
    filterObj = { ...filterObj, ...filterObjPatch }
  }
  const getFilterObj = () => {
    return filterObj;
  }
  const resetMovementDetailGoodtype = (inputGoodTypeOrder) => {
    let currentIndex = 0;
    for (const prop in movementDetail) {
      if (currentIndex <= CATEGORY_ORDER.BASIC_MODEL) {
        if (currentIndex > inputGoodTypeOrder) {
          movementDetail[prop] = { id: null, code: null, name: null };
        }
      }

      currentIndex++;
    }
    goodMovementModel.setMovementDetail(movementDetail);
  };
  const onDownLoadGoodMovement = () => {
    return goodMovementModel.downloadGoodMovement({ ...currentFilter, sortBy: sortObj.sortBy ? `[${sortObj.sortBy}]` : '', orderBy: sortObj.orderBy })
  }
  const setCurrentFilter = () => {
    currentFilter = {
      ...filterObj,
      MainId: goodMovementModel.movementDetail?.main?.id,
      GoodsTypeId: goodMovementModel.movementDetail?.goodsType?.id,
      DivisionId: goodMovementModel.movementDetail?.division?.id,
      ModelId: goodMovementModel.movementDetail?.model?.id,
      BasicModelId: goodMovementModel.movementDetail?.basicModel?.id,
      MovementTypeCode: goodMovementModel.movementDetail?.movementType?.code,
      WarehouseCode: goodMovementModel.movementDetail?.warehouse?.code,
      StorageLocationCode: goodMovementModel.movementDetail?.storageLocation?.code
    }
    filterObj = currentFilter;
  }
  const onSearchForGoodMovementList = (refreshPagination = false) => {
    this.showLoading();
    if (refreshPagination) {
      setPaginationObj({ pageIndex: 1, pageSize: 10 })
    }
    goodMovementModel.getListGoodMovement({ ...currentFilter, sortBy: sortObj.sortBy ? `[${sortObj.sortBy}]` : '', orderBy: sortObj.orderBy }).then((data) => {
      totalListGoodMovement = data.total;
      listGoodMovement = data.data;
    }).catch((err) => {
      this.handleError(err);
    })
      .finally(() => {
        this.hideLoading()
      })
  }

  const onSelect = (s, categoryName, categoryOrderName, categoryOrderChildName, categoryChildName) => {
    const oldCode = movementDetail[categoryName]?.id
    movementDetail[categoryName] = s;
    if (s.id) {
      if (s.id != oldCode) {

        isHierachyLoading = true;
        currentInputGoodTypeOrder = CATEGORY_ORDER[categoryOrderChildName];
        resetMovementDetailGoodtype(
          currentInputGoodTypeOrder
        );
        goodMovementModel
          .getHierachyTreeByParentCode(s.id)
          .then((data) => {
            goodMovementModel.setHierachyOptions(
              categoryChildName,
              data
            );
            MOVEMENT_OPTIONS[categoryChildName] =
              goodMovementModel.createHierachyOptions(
                data
              );
            isHierachyLoading = false;
          })
          .catch((err) => {
            isHierachyLoading = false;
            handleError(err);
          });
        movementDetail[categoryChildName] = { id: null, code: null, name: null };
      }
    } else {
      currentInputGoodTypeOrder = CATEGORY_ORDER[categoryOrderName];
      movementDetail[categoryName] = {
        id: null,
        name: null,
        code: null,
      };

      resetMovementDetailGoodtype(
        CATEGORY_ORDER[categoryOrderName]
      );
    }
    goodMovementModel.setMovementDetail(movementDetail);
  }
  const onSelectBasicModel = (s) => {
    const oldCode = movementDetail.basicModel.id;
    movementDetail.basicModel = s;
    goodMovementModel.setMovementDetail(movementDetail);
    if (s.id) {
      if (s.id != oldCode) {
        currentInputGoodTypeOrder =
          CATEGORY_ORDER.BASIC_MODEL;
      }
    } else {
      currentInputGoodTypeOrder =
        CATEGORY_ORDER.BASIC_MODEL;
      movementDetail.basicModel = {
        id: null,
        name: null,
        code: null,
      };
    }
  }
  const handleError = this.handleError;
  const getFirstLevelOptions = () => {
    goodMovementModel
      .getHierachyTreeByLevel(1, 1)
      .then((data) => {
        MOVEMENT_OPTIONS.main =
          goodMovementModel.createHierachyOptions(data);
        goodMovementModel.setHierachyOptions('main', data);
        isHierachyLoading = false;
      })
      .catch((err) => {
        isHierachyLoading = false;
        handleError(err);
      });
  }
  const getChildOptions = (parentCode, currentProp) => {
    goodMovementModel
      .getHierachyTreeByParentCode(parentCode)
      .then((data) => {
        MOVEMENT_OPTIONS[currentProp] = goodMovementModel.createHierachyOptions(data);
        goodMovementModel[currentProp] = goodMovementModel.createHierachyOptions(data);
        isHierachyLoading = false;

      })
      .catch((err) => {
        isHierachyLoading = false;
        handleError(err);
      });
  }
  const getCurrentParent = () => {
    let currentIndex = 0;
    let parentCode = '';
    let currentProp = '';
    for (const prop in movementDetail) {
      if (currentIndex <= CATEGORY_ORDER.BASIC_MODEL) {
        if (!movementDetail[prop]?.id) {
          currentInputGoodTypeOrder = currentIndex;
          currentProp = prop;
          break;
        } else {
          parentCode = movementDetail[prop]?.id;
        }
      }
      currentIndex++;
    }
    return {
      currentIndex,
      parentCode,
      currentProp
    }
  }
  let hierachyLabels = [];

  let clearMovementTypeFunction = () => { }

  const handleClear = () => {
    onSelect({ id: null, code: null, name: null }, 'main', 'MAIN', 'GOODS_TYPE', 'goodsType')
    clearMovementTypeFunction()
    filterObj = structuredClone(DEFAULT_FILTERS);
    setCurrentFilter();
  }
  let previousMovementTypeCode = '';
  let previousWarehouseCode = '';
  let userMovementWarehouseMapAuthority = false;
  const checkUserMovementWarehouseMapAuthorization = (movementType, warehouseID) => {
    previousMovementTypeCode = movementType;
    previousWarehouseCode = warehouseID;
    goodMovementModel.checkUserMovementWarehouseMapAuthorization({ movementType, warehouseID })
      .then((result) => {
        userMovementWarehouseMapAuthority = result === 'Y';
      })
      .catch((error) => {
        this.handleError(error)
      })
  }

  let sortObj = {
    sortBy: '',
    orderBy: '',
  }

  const _flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT
  }

  const onSortClick = (sortBy) => {
    if (sortObj.sortBy === sortBy) {
      sortObj.orderBy = _flipOrderText(sortObj.orderBy)
    } else {
      sortObj.sortBy = sortBy;
      sortObj.orderBy = DESCENDING_TEXT;
    }
    onSearchForGoodMovementList();
  }

  return {
    oninit: function () {
      isHierachyLoading = true;
      hierachyLabels = goodMovementModel.taiwanHierachyLabel
      const currentParentObj = getCurrentParent();
      currentInputGoodTypeOrder = currentParentObj.currentIndex
      getFirstLevelOptions();
      if (currentParentObj.parentCode) {
        getChildOptions(currentParentObj.parentCode, currentParentObj.currentProp);
      }
      setCurrentFilter();
      setPaginationObj();
      onSearchForGoodMovementList();
    },
    //Check Posm User Movement Warehouse Map Authorization
    onupdate: () => {
      if (goodMovementModel.movementDetail.basicModel.id && goodMovementModel.movementDetail.storageLocation.code) {
        if (previousMovementTypeCode != goodMovementModel.movementDetail.movementType.code || previousWarehouseCode != goodMovementModel.movementDetail.warehouse.code) {
          checkUserMovementWarehouseMapAuthorization(goodMovementModel.movementDetail.movementType.code, goodMovementModel.movementDetail.warehouse.code)
        }
      } else userMovementWarehouseMapAuthority = false;
    },
    onremove: function () {
      if (!goodMovementModel.isGoingtoHierachy) {
        goodMovementModel.resetMovementDetail();
      }
    },

    view: () => {
      return [
        /* SEARCH */
        isHierachyLoading &&
        m(Spinner, { fill: true, background: true, active: true }),
        m('.card.mb-3',
          m('.card-body',
            m('.position-relative',
              m('.row.row-cols-5.g-2.mb-2',
                m('.col.position-relative', [
                  m('label.form-label', this.getText(hierachyLabels[0][1], hierachyLabels[0][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      popoverAttrs: { class: 'posm-filters' },
                      items: MOVEMENT_OPTIONS.main,
                      selectedItem: movementDetail.main,
                      checkmark: true,
                      filterable: true,
                      onSelect: (s) => {
                        onSelect(s, 'main', 'MAIN', 'GOODS_TYPE', 'goodsType')
                      },
                    }),
                  ),
                ]),
                m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.GOODS_TYPE && [
                  m('label.form-label', this.getText(hierachyLabels[1][1], hierachyLabels[1][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      activeIndex: (goodMovementModel.goodsType.findIndex((item) => { return item.id == movementDetail.goodsType.id }) + 1) || 0,
                      popoverAttrs: { class: 'posm-filters' },
                      allowEmpty: MOVEMENT_OPTIONS.goodsType.length != 0,
                      items: MOVEMENT_OPTIONS.goodsType,
                      selectedItem: movementDetail.goodsType,
                      checkmark: true,
                      filterable: true,

                      onSelect: (s) => {
                        onSelect(s, 'goodsType', 'GOODS_TYPE', 'DIVISION', 'division')
                      },
                    }),
                    !movementDetail.goodsType.id &&
                    POSMAuthorizationModel.loadWithPOSMAuthority(
                      m('button.btn.btn-sm.btn-primary',
                        {
                          onclick: () => {
                            goodMovementModel.setMovementDetail(
                              movementDetail
                            );
                            goodMovementModel.isFromPOSMGoodMovement = true;
                            m.route.set('/posm-global-hierarchy');
                            goodMovementModel.isGoingtoHierachy = true;
                          },
                        },
                        [m('i.bi.bi-plus-lg.me-0')]
                      ),
                      POSM_PERMISSION_KEY.NEW_GOODS_TYPE
                    )

                  )
                ]),


                m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.DIVISION && [
                  m('label.form-label', this.getText(hierachyLabels[2][1], hierachyLabels[2][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      activeIndex: (goodMovementModel.division.findIndex((item) => { return item.id == movementDetail.division.id }) + 1) || 0,
                      popoverAttrs: { class: 'posm-filters' },
                      allowEmpty: MOVEMENT_OPTIONS.division.length != 0,
                      items: MOVEMENT_OPTIONS.division,
                      selectedItem: movementDetail.division,
                      checkmark: true,
                      filterable: true,
                      onSelect: (s) => {
                        onSelect(s, 'division', 'DIVISION', 'MODEL', 'model')
                      },
                    }),
                    !movementDetail.division.id &&
                    POSMAuthorizationModel.loadWithPOSMAuthority(
                      m('button.btn.btn-sm.btn-primary',
                        {
                          onclick: () => {
                            goodMovementModel.setMovementDetail(
                              movementDetail
                            );
                            goodMovementModel.isFromPOSMGoodMovement = true;
                            m.route.set('/posm-global-hierarchy');
                            goodMovementModel.isGoingtoHierachy = true;
                          },
                        },
                        [m('i.bi.bi-plus-lg.me-0')]
                      ),
                      POSM_PERMISSION_KEY.NEW_DIVISION
                    )
                  ),
                ]),

                m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.MODEL && [
                  m('label.form-label', this.getText(hierachyLabels[3][1], hierachyLabels[3][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      activeIndex: (goodMovementModel.model.findIndex((item) => { return item.id == movementDetail.model.id }) + 1) || 0,
                      popoverAttrs: { class: 'posm-filters' },
                      allowEmpty: MOVEMENT_OPTIONS.model.length != 0,
                      items: MOVEMENT_OPTIONS.model,
                      selectedItem: movementDetail.model,
                      checkmark: true,
                      filterable: true,
                      onSelect: (s) => {
                        onSelect(s, 'model', 'MODEL', 'BASIC_MODEL', 'basicModel')
                      },
                    }),
                    !movementDetail.model.id &&
                    POSMAuthorizationModel.loadWithPOSMAuthority(
                      m('button.btn.btn-sm.btn-primary',
                        {
                          onclick: () => {
                            goodMovementModel.setMovementDetail(
                              movementDetail
                            );
                            goodMovementModel.isFromPOSMGoodMovement = true;
                            m.route.set('/posm-global-hierarchy');
                            goodMovementModel.isGoingtoHierachy = true;
                          },
                        },
                        [m('i.bi.bi-plus-lg.me-0')]
                      ),
                      POSM_PERMISSION_KEY.NEW_MODEL
                    )
                  ),
                ]),

                m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.BASIC_MODEL && [
                  m('label.form-label', this.getText(hierachyLabels[4][1], hierachyLabels[4][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      activeIndex: (goodMovementModel.basicModel.findIndex((item) => { return item.id == movementDetail.basicModel.id }) + 1) || 0,
                      popoverAttrs: { class: 'posm-filters' },
                      allowEmpty: MOVEMENT_OPTIONS.basicModel.length != 0,
                      items: MOVEMENT_OPTIONS.basicModel,
                      selectedItem: movementDetail.basicModel,
                      checkmark: true,
                      filterable: true,
                      onSelect: (s) => {
                        onSelectBasicModel(s);
                      },
                    }),
                    !movementDetail.basicModel.id &&
                    POSMAuthorizationModel.loadWithPOSMAuthority(
                      m('button.btn.btn-sm.btn-primary',
                        {
                          onclick: () => {
                            goodMovementModel.setMovementDetail(
                              movementDetail
                            );
                            goodMovementModel.isFromPOSMGoodMovement = true;
                            m.route.set('/posm-global-hierarchy');
                            goodMovementModel.isGoingtoHierachy = true;
                          },
                        },
                        [m('i.bi.bi-plus-lg.me-0')]
                      ),
                      POSM_PERMISSION_KEY.NEW_BASIC_MODEL
                    )
                  ),
                ])
              ),
              m(POSMmovementTypeView, { clearMovementType: (fn) => { clearMovementTypeFunction = fn } }),
              (goodMovementModel.movementDetail.basicModel?.id && goodMovementModel.movementDetail.storageLocation?.code) &&
              userMovementWarehouseMapAuthority &&
              POSMAuthorizationModel.loadWithPOSMAuthority(
                m('button.btn.btn-primary.position-absolute.bottom-0.end-0',
                  {
                    onclick: () => {
                      isCreateMovementDialogOpen = true;
                    },
                  },
                  m('i.bi.bi-plus-lg.me-0'),
                  goodMovementModel.movementDetail.movementType?.name
                ),
                CREATE_GOODS_MOVEMENT_AUTHORITY_MAP[goodMovementModel.movementDetail.movementType?.code]
              )
            ),
            m('hr'),
            m(POSMGoodsMovementFooter, { filterObj, onSearchForGoodMovementList, setFilterObj, setCurrentFilter, handleClear }),
          )),
        m(DisplayAllGoodmovement, {
          listGoodMovement,
          totalItems: totalListGoodMovement,
          onSearchForGoodMovementList,
          onDownLoadGoodMovement,
          setPaginationObj,
          setFilterObj,
          getFilterObj,
          paginationObj,
          onOpenMovementDetail: (code) => {
            isCreateMovementDialogOpen = true;
            movementControlCode = code;
          },
          sortObj,
          onSortClick
        }),

        /* CREATE GOODS MOVEMENT DIALOG */
        isCreateMovementDialogOpen &&
        m(CreatePOSMGoodsMovementDialog, {
          isOpen: isCreateMovementDialogOpen,
          onClose: (refresh = false) => {
            isCreateMovementDialogOpen = false;
            movementControlCode = '';
            if (refresh === true)
              onSearchForGoodMovementList(true);

          },
          movementControlCode,
        }),

        this.getBaseViews(),
      ];
    },
  };
}
